import { EvmNFTCollection } from '@repo/types-client';

import { ethereumContractAddresses } from './ethereum-contract-addresses';

export interface EthereumNFTCollections {
  readonly doodles: EvmNFTCollection;
  readonly spaceDoodles: EvmNFTCollection;
  readonly dooplicator: EvmNFTCollection;
  readonly genesisBox: EvmNFTCollection;
  readonly doodlesDrops: EvmNFTCollection;
}

export const ethereumNFTCollections: EthereumNFTCollections = {
  doodles: {
    contractName: 'Doodles',
    getAddress: () => ethereumContractAddresses.doodles,
    getMetadataURI: (tokenId: string) =>
      `ipfs://QmPMc4tcBsMqLRuCQtPmPe84bpSjrC3Ky7t3JWuHXYB4aS/${tokenId}`,
    tokenType: 'ERC721',
    chain: 'ethereum',
  },
  spaceDoodles: {
    contractName: 'SpaceDoodles',
    getAddress: () => ethereumContractAddresses.spaceDoodles,
    getMetadataURI: (tokenId: string) =>
      `https://api.spacedoodles.xyz/${tokenId}`,
    tokenType: 'ERC721',
    chain: 'ethereum',
  },
  dooplicator: {
    contractName: 'Dooplicator',
    getAddress: () => ethereumContractAddresses.dooplicator,
    getMetadataURI: (tokenId: string) =>
      `https://metadata.artlab.xyz/0185fa75-ba04-8156-9fbe-bb39dc263392/${tokenId}`,
    tokenType: 'ERC721',
    chain: 'ethereum',
  },
  genesisBox: {
    contractName: 'GenesisBox',
    getAddress: () => ethereumContractAddresses.genesisBox,
    getMetadataURI: (tokenId: string) =>
      `https://wcnft.mypinata.cloud/ipfs/QmZpBqpQEsrGFsa11S2woWi823mCaaYcGQbwzz7BoS3g8s/${tokenId}`,
    tokenType: 'ERC721',
    chain: 'ethereum',
  },
  doodlesDrops: {
    contractName: 'DoodlesDrops',
    getAddress: () => ethereumContractAddresses.doodlesDrops,
    getMetadataURI: (tokenId: string) => {
      switch (tokenId) {
        case '0':
          return 'ipfs://bafkreid2w2pjbpfx64vywyhis47uqz5ru5nvsxjfxxwlj2tchfqvm5faki';
        case '1':
          return 'ipfs://bafkreifkzqzqrv45dopzlyzqo5dygssm3qt4adixihrlyv3atwbcdplb2u';
        case '2':
          return 'ipfs://bafkreifjk67kotblfve3vdmjoez5z3nfcmffjbxofxxlb5od25t44jyaim';
        case '3':
          return 'ipfs://bafkreih6ixfkaxqg5afvmjnblifmqxivwajdnngmcx4wqbujzv6umox6du';
        case '4':
          return 'ipfs://bafkreic5snnbmv3dru6zzjrt5ybueoabewbm5tpzb4xhrrjbfmjipe5p2i';
        default:
          return '';
      }
    },
    tokenType: 'ERC1155',
    chain: 'ethereum',
  },
} as const;
